import './globals';
import {Collapse} from "bootstrap";

/**
 * Initialize accordion elements
 */
(function (PageLoadedQueue) {
    const collapseHide = (trigger) => {
        trigger.ariaExpanded = false;
        trigger.classList.add('collapsed');
    }

    const collapseShow = (trigger) => {
        trigger.ariaExpanded = true;
        trigger.classList.remove('collapsed');
    }

    const initCollapse = (accordionEl) => {
        const trigger = accordionEl.querySelector('[data-plandent-toggle="collapse"]');
        const collapseEl = accordionEl.querySelector('.collapse');

        if (!trigger || !collapseEl) {
            return;
        }

        const toggle = collapseEl.classList.contains('show');

        let collapse = Collapse.getOrCreateInstance(collapseEl, {
            toggle: false
        });

        if (toggle) {
            collapseShow(trigger);
            collapse.show();
        } else {
            collapseHide(trigger);
            collapse.hide();
        }

        trigger.addEventListener('click', () => {
            if (trigger.classList.contains('collapsed')) {
                collapse.show();
                collapseShow(trigger);
            } else {
                collapse.hide();
                collapseHide(trigger);
            }
        }, {passive: true});

        collapseEl.addEventListener('hide.bs.collapse', () => {
            collapseHide(trigger);
        }, {passive: true});

        collapseEl.addEventListener('show.bs.collapse', () => {
            collapseShow(trigger);
        }, {passive: true});
    }

    window.PageLoadedQueue.addFunction(function () {
        const accordions = document.querySelectorAll('.accordion-item');
        if (accordions.length) {
            Array.from(accordions).forEach((accordionEl) => {
                initCollapse(accordionEl);
            });
        }
    });
})(window.PageLoadedQueue);
